import AddRepoImg from "../../assets/img/add-repo.svg";
import SignOutImg from "../../assets/img/sign-out.svg";
import { useNavigate } from "react-router-dom";
import { logoutAction } from "../../store/auth-actions";
import { useAppDispatch } from "../../hooks/redux-hooks";
import AddRepositoryModal from "../AddRepositoryModal/AddRepositoryModal";
import { useState } from "react";
import SearchModal from "../SearchModal/SearchModal";

// FileUploadModal

type MainNavbarProps = {
  createRepository: (repoName: string) => Promise<void>;
  searchAndCreateRepository: (repoName: string) => Promise<void>;
  repositoryName: string | null;
  paperName: string | null;
};

const MainNavbar = (props: MainNavbarProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [modalShow, setModalShow] = useState(false);

  const [searchModalShow, setSearchModalShow] = useState(false);

  const onSignOutClick = async () => {
    await dispatch(logoutAction());
    navigate("/auth");
  };

  return (
    <>
      <nav className="navbar navbar-dark sticky-top flex-md-nowrap p-0">
        <div className="col-md-3">
          <li className="btn add-repo" onClick={() => setModalShow(true)}>
            <img alt="add repo" src={AddRepoImg} />
            Add Repository
          </li>
          <li
            className="btn search-papers"
            onClick={() => setSearchModalShow(true)}
          >
            Search papers
          </li>
        </div>
        <nav
          aria-label="breadcrumb"
          className="col-md-6 d-flex align-items-center justify-content-between"
        >
          <ol className="breadcrumb">
            {props.repositoryName && (
              <li className="breadcrumb-item">
                <a href="/#">{props.repositoryName}</a>
              </li>
            )}
            {props.paperName && (
              <li className="breadcrumb-item active">
                <a href="/#">{props.paperName}</a>
              </li>
            )}
          </ol>
          <div className="nex-pre-buttons">
            {/* <button className="btn">Back</button> */}
            {/* <button className="btn next">Next</button> */}
          </div>
        </nav>
        <div className="col-md-3 text-right">
          <a className="nav-link signout" href="/#" onClick={onSignOutClick}>
            <img alt="" src={SignOutImg} />
            Sign Out
          </a>
        </div>
      </nav>

      <AddRepositoryModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        createRepository={props.createRepository}
      />

      <SearchModal
        show={searchModalShow}
        onHide={() => setSearchModalShow(false)}
        searchAndCreateRepository={props.searchAndCreateRepository}
      />
    </>
  );
};

export default MainNavbar;
